import { css } from '@compiled/react';

import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

export type JsmPlaygroundRedactedLineProps = {
	/** Width in px. */
	width: number;
};

/**
 * A grey bar standing in for text the preview deliberately withholds — the lower rows of a queue,
 * a response nobody needs to read. It keeps the shape of the content without inviting the eye to
 * read fabricated copy, so it carries no text for assistive technology either.
 */
export const JsmPlaygroundRedactedLine = ({ width }: JsmPlaygroundRedactedLineProps) => (
	<span aria-hidden="true" css={redactedLineStyles}>
		<Skeleton
			borderRadius={token('radius.xsmall')}
			height="10px"
			isShimmering={false}
			width={`${width}px`}
		/>
	</span>
);

const redactedLineStyles = css({
	display: 'inline-flex',
	flexShrink: 0,
});
